import { createContext, useContext } from 'react';
// Create the context with default values
export const InternationalizationContext = createContext(undefined);
// Create a hook for consuming the context
export function useInternationalization() {
    const context = useContext(InternationalizationContext);
    if (!context) {
        throw new Error('useInternationalization must be used within an InternationalizationProvider');
    }
    return context;
}
